// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__Brti4","legacyBtn":"MutateMid_legacyBtn__CNalh"};